export const normalizeRLPStatusResponse = payload => !!payload.Rlp;
